import {lazy, Suspense} from 'react';
import {Loading} from 'components/loading/Loading';
import {useAppOverrides} from 'contexts/AppOverridesContext';

/**
 * Default CIP landing page, loaded lazily to keep the initial bundle small.
 * Only resolved when no {@link AppOverrides.SplashPage} override is present.
 */
const DefaultLanding = lazy(() => import('./default'));

/**
 * Index-route element for `/`.
 *
 * Reads {@link AppOverrides.SplashPage} from {@link AppOverridesContext}:
 * - When an override is provided, renders it directly.
 * - Otherwise, renders the default CIP {@link Landing} component behind a
 *   `<Suspense>` boundary so the lazy chunk is only fetched on demand.
 *
 * This is the single touch-point that lets external deploy wrappers (e.g. PAI)
 * substitute a custom landing page without editing any CIP source file.
 */
export function SplashPageRoute() {
  const {SplashPage} = useAppOverrides();
  if (SplashPage) {
    return <SplashPage />;
  }
  return (
    <Suspense fallback={<Loading />}>
      <DefaultLanding />
    </Suspense>
  );
}
